import Request from '@/api/request';

export interface IRegion {
  regionName: string;
  regionCode: string;
  regionFiasId: string;
}

const api = new Request('lk/');

export function getRegionList(): Promise<IRegion[]> {
  return api.get('getRegions');
}
